import { BackgroundImageSize } from "interfaces/images";

interface Props {
	src: string;
	isBackground?: boolean;
	width?: number;
	height?: number;
	fullWidth?: boolean;
	fullHeight?: boolean;
	backgroundSize?: BackgroundImageSize;
	borderRadius?: number;
}

const Image = (props: Props): JSX.Element => {
	const {
		src,
		isBackground,
		width,
		height,
		fullHeight,
		fullWidth,
		backgroundSize,
		borderRadius,
	} = props;

	if (isBackground) {
		return (
			<div
				className="flex max-w-full bg-center bg-no-repeat"
				style={{
					width: width ? `${width}px` : "100%",
					height: height ? `${height}px` : "100%",
					backgroundImage: `url(${src})`,
					backgroundSize: backgroundSize || "contain",
					borderRadius: borderRadius ? `${borderRadius}px` : 0,
				}}
			/>
		);
	}

	return (
		<img
			src={src}
			className="flex max-w-full"
			style={{
				width: fullWidth ? "100%" : width ? `${width}px` : "100%",
				height: fullHeight ? "100%" : height ? `${height}px` : "auto",
				borderRadius: borderRadius ? `${borderRadius}px` : 0,
			}}
		/>
	);
};

export default Image;
